import type { ReactNode } from 'react';

interface Props {
  /** Formular-Überschrift, z. B. "Anmelden". */
  title: string;
  subtitle?: string;
  children: ReactNode;
  /** Optionaler Fußtext unterhalb der Karte, z. B. "Noch kein Konto? …". */
  footer?: ReactNode;
}

const WORKSHOP_IMAGE =
  'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?q=80&w=2072&auto=format&fit=crop';

/**
 * Gemeinsames Layout für Login, Registrierung, Passwort-vergessen und
 * Passwort-zurücksetzen: Bild links, Formular-Card rechts.
 */
export function AuthLayout({ title, subtitle, children, footer }: Props) {
  return (
    <div className="h-screen flex overflow-hidden">
      {/* Linke Seite – Bild */}
      <div className="hidden lg:flex lg:w-1/2 relative">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat brightness-75"
          style={{ backgroundImage: `url(${WORKSHOP_IMAGE})` }}
        />
        <div className="absolute top-8 left-8 z-10">
          <h1 className="font-display text-4xl font-bold text-white drop-shadow-lg">
            Zeiterfassung
          </h1>
          <p className="text-xl text-white/90 drop-shadow-md">@ Werkstatt-Connect</p>
        </div>
      </div>

      {/* Rechte Seite – Formular */}
      <div className="flex-1 flex flex-col bg-background overflow-y-auto">
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="max-w-md w-full">
            {/* Mobile Header */}
            <div className="lg:hidden text-center mb-8">
              <h1 className="font-display text-3xl font-bold text-foreground">Zeiterfassung</h1>
              <p className="text-lg text-muted-foreground">@ Werkstatt-Connect</p>
            </div>

            {/* Form Card */}
            <div className="bg-card rounded-2xl shadow-lg border border-border/60 p-8 space-y-6">
              <div>
                <h2 className="font-display text-2xl font-bold text-foreground">{title}</h2>
                {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
              </div>
              {children}
            </div>

            {footer && <div className="text-center text-sm text-muted-foreground mt-6">{footer}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
